import { OrderWithPartialLines } from 'src/redux/reducers/orders'

const recipientCount = (order: OrderWithPartialLines) =>
  order.groups.reduce(
    (count, group) => count + group.members.length,
    order.contacts.length,
  )

export default recipientCount
